var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileGetHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 8,
    viewBox: "0 0 17 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3703 1.82356C16.3238 2.07862 13.7968 4.19802 11.4433 4.99287C11.0009 5.14266 10.8397 5.17437 10.0681 5.21553C8.25213 5.31352 8.1732 5.34065 6.21729 5.34065C5.35944 5.34065 3.59558 7.07674 3.59558 7.07674L0.74707 4.31673C0.74707 4.31673 2.5899 1.37641 3.73389 0.93965C4.54414 0.629996 6.23403 0.701093 7.66248 0.506789C9.54728 0.24977 10.1016 0.0179508 11.0463 0.0022721C11.7613 -0.0094869 11.8879 1.36751 10.3872 2.02742C10.1044 2.15229 8.70235 2.48627 8.35742 2.64754C8.35742 2.64754 10.5944 3.17053 12.0318 2.5207C13.2043 1.98959 14.42 1.06622 15.3439 1.00911C15.8322 0.978591 16.4778 1.23309 16.3703 1.82356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGetHelpIcon);
export default __webpack_public_path__ + "static/media/profile-get-help-icon.7bbc5b06763256b788f7c58f9cb07f8b.svg";
export { ForwardRef as ReactComponent };